var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveStreaming = function SvgLiveStreaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM10.083 11a.917.917 0 1 1 1.834 0 .917.917 0 0 1-1.834 0ZM5.167 5.167a.917.917 0 1 0-1.296-1.296 10.083 10.083 0 0 0 0 14.258.917.917 0 0 0 1.296-1.296 8.25 8.25 0 0 1 0-11.666ZM18.13 3.871a.917.917 0 0 0-1.297 1.296 8.25 8.25 0 0 1 0 11.666.917.917 0 0 0 1.297 1.296 10.084 10.084 0 0 0 0-14.258ZM7.761 7.753a.917.917 0 1 0-1.296-1.297 6.417 6.417 0 0 0 0 9.08.917.917 0 0 0 1.296-1.298 4.584 4.584 0 0 1 0-6.485Zm7.773-1.288a.917.917 0 1 0-1.295 1.297 4.583 4.583 0 0 1 0 6.485.917.917 0 1 0 1.295 1.297 6.417 6.417 0 0 0 0-9.08Z",
    clipRule: "evenodd"
  })));
};
export default SvgLiveStreaming;